import type { CSSProperties, KeyboardEventHandler } from "react";
import { Button, Input, SearchField } from "react-aria-components";

import searchIcon from "@/assets/figma/experience-strategy/search.svg";
import clearIcon from "@/assets/figma/chat-attachments/close.svg";
import { cn } from "@/shared/lib/cn";
import "./merry-search-field.css";

export interface MerrySearchFieldProps {
  "aria-label"?: string;
  autoFocus?: boolean;
  className?: string;
  isDisabled?: boolean;
  maxLength?: number;
  name?: string;
  onChange: (value: string) => void;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  onSubmit?: (value: string) => void;
  placeholder?: string;
  size?: 34 | 48;
  value: string;
  width?: CSSProperties["width"];
}

/** A width-flexible search input with the 34px and 48px Merry variants. */
export function MerrySearchField({
  "aria-label": ariaLabel,
  autoFocus = false,
  className,
  isDisabled = false,
  maxLength,
  name,
  onChange,
  onKeyDown,
  onSubmit,
  placeholder = "搜索",
  size = 48,
  value,
  width,
}: MerrySearchFieldProps) {
  return (
    <SearchField
      aria-label={ariaLabel ?? placeholder}
      className={cn("merry-search-field", className)}
      data-has-value={value.length > 0}
      data-size={size}
      isDisabled={isDisabled}
      name={name}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onSubmit={onSubmit}
      style={width === undefined ? undefined : { width }}
      value={value}
    >
      <img alt="" aria-hidden="true" className="merry-search-field__icon" src={searchIcon} />
      <Input autoFocus={autoFocus} className="merry-search-field__input" maxLength={maxLength} placeholder={placeholder} />
      {value.length > 0 && (
        <Button
          aria-label="清除搜索内容"
          className="merry-search-field__clear"
          type="button"
        >
          <img alt="" aria-hidden="true" src={clearIcon} />
        </Button>
      )}
    </SearchField>
  );
}
